import type { Theme } from '@mui/material';

export const styles = {
  bulkEditDialog: {
    '& .MuiPaper-root': {
      flexBasis: '800px',
      maxWidth: '800px',
    },
    '& .MuiDialogContent-root': {
      paddingTop: 3.125,
      paddingBottom: 2.5,
      overflowY: 'initial', // prevents horizontal scroll bar
    },
    '& .MuiStepper-root': {
      marginBottom: 2.75,
    },
    '& .MuiDialogActions-root': {
      paddingBottom: 0,
    },
  },

  questionStack: {
    '& .MuiStack-root': {
      gap: 2.125,
    },
  },

  editTypeQuestion: {
    marginBottom: 1,
  },

  questionSubtitle: (theme: Theme) => ({
    color: theme.colors.neutral[600],
    fontWeight: 600,
  }),

  toggleButton: (theme: Theme) => ({
    height: '100%',
    whiteSpace: 'unset',
    minHeight: '6.25rem',
    color: theme.colors.neutral[500],
    borderColor: theme.colors.neutral[200],
    borderRadius: '8px',
    '&:hover, &.Mui-selected, &.Mui-selected:hover': {
      color: theme.colors.neutral[500],
      borderColor: theme.colors.neutral[200],
      backgroundColor: theme.colors.neutral[100],
    },
  }),

  divider: (theme: Theme) => ({
    borderColor: theme.colors.neutral[200],
    // compensate for paddings to display over whole dialog
    marginLeft: -4,
    marginRight: -4,
  }),
};
